const location = '/location';
const missions = '/mission';
const detections = '/zonedetection';
const subscriptions = '/billing-plans';

export const greenhouseEndpoints = { location, missions, detections, subscriptions };
